import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Primitive } from '@radix-ui/react-primitive';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useChipContext } from '../../context.mjs';
import { chipLabel, chipLabelHorizontalGap } from './label.vanilla.mjs';

const ChipLabel = forwardRef(
  ({ className: classNameFromProps, space, style: styleFromProps, ...props }, forwardedRef) => {
    const { state } = useChipContext("Chip.Label");
    const className = classNames(chipLabel, classNameFromProps);
    const styles = Object.assign(
      {},
      assignInlineVars({
        [chipLabelHorizontalGap]: space !== void 0 ? `${space}px` : null
      }),
      styleFromProps
    );
    return /* @__PURE__ */ jsx(
      StyledDiv,
      {
        "data-scope": "chip",
        "data-part": "label",
        "data-chip-state": state,
        className,
        style: styles,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const StyledDiv = styled(Primitive.div);
ChipLabel.displayName = "Chip.Label";
ChipLabel.toString = () => '[data-scope="chip"][data-part="label"]';

export { ChipLabel };
//# sourceMappingURL=Label.mjs.map
